<template>
	<div class="p-5">
		<h1>Meddelandet skickat!</h1>
		<p>
			Ditt meddelande har skickats och vi svarar så snart vi kan.
			Vi har som mål att svara inom 24 timmar på vardagar, men under helger och kampanjer kan svar dröja lite längre.
		</p>
		<p>
			Våra öppettider är 08.00 - 17.00 på vardagar.
		</p>
		<div>
			<text-button
				text="Tillbaka!"
				@click="$router.go(-1)"
			/>
		</div>
		<img class="pt-4" :src="imageSource" style="width: 100%" alt="thankyou" />
	</div>
</template>

<script>
import { convertToCdnUrl } from 'utils';
export default {
	layoutOptions: {
		leftCol: true,
	},
	data () {
		return {};
	},
	computed: {
		imageSource() {
			return convertToCdnUrl('/images/545753-infokundservice1200');
		},
	},
};
</script>